import React from 'react'
import "../stylesheets/about.css"
export default function About() {
  return (
    <div className='abmain' id='about'>
        <div className='abmainch1'>
             <span>
                About me
             </span>
             <p>
             Hello all, I am Siyab Arshad a Full-Stack developer having 2+ years of experience. I am highly focused on a variety of development and love to create Mobiles apps, and websites. I have advanced skills in JavaScript, React Native, React js, Node js, Firebase, MySQL, and Mongo Db. I will give you 100% satisfaction in my service Available 24/7. I believe in 3 things Communication, Quality, and Support. If you have any questions please don't hesitate to contact me. Let us help each other in this hard time.
            Thanks.

             </p>
        </div>
    </div>
  )
}
